import type { BlockProps } from '../types.js'
import { SectionWrapper } from './SectionWrapper.js'
import { EMPTY_ARRAY } from './formatters.js'
import styles from './common.module.css'

export function ScheduleBlock({ invitation, activeSection, onSectionClick, mode }: BlockProps) {
  const schedule = invitation.schedule ?? EMPTY_ARRAY

  return (
    <SectionWrapper
      sectionId="schedule"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={styles.section}
    >
      <span className={styles.sectionTitle}>식순</span>
      <div className={styles.divider} />
      {schedule.length > 0
        ? (
          <div className={styles.verticalTimeline}>
            {schedule.map((item, i) => (
              <div key={i} className={styles.timelineRow}>
                <div className={styles.timelineTrack}>
                  <div className={styles.timelineDot} />
                  {i < schedule.length - 1 && <div className={styles.timelineLine} />}
                </div>
                <div className={styles.timelineContent}>
                  <span className={styles.timelineTime}>{item.time}</span>
                  <span className={styles.timelineTitle}>{item.title}</span>
                  {item.description && (
                    <span className={styles.timelineDesc}>{item.description}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )
        : <p className={styles.placeholderText}>식순이 여기에 표시됩니다</p>
      }
    </SectionWrapper>
  )
}
